interface IModuloCheck {
    isValid(healthCardNumber: string): boolean;
}

abstract class ModuloCheck implements IModuloCheck {
    protected abstract get multipliers(): number[];
    protected abstract get moduloValue(): number;
    protected abstract applyFormula(multiplicationResult: number): number;

    public isValid(healthCardNumber: string): boolean {
        if (healthCardNumber === null || !healthCardNumber.isNumber() || healthCardNumber.length !== this.multipliers.length)
            return false;

        let sum = 0;
        for (let i = 0; i < healthCardNumber.length; i++) {
            let digit = Number(healthCardNumber[i]);
            sum += this.applyFormula(digit * this.multipliers[i]);
        }

        return sum % this.moduloValue === 0;
    }
}

class BritishColumbiaModuloCheck extends ModuloCheck {
    protected get multipliers(): number[] {
        return [0, 2, 4, 8, 5, 10, 9, 7, 3, 1];
    }

    protected get moduloValue(): number {
        return 11;
    }

    protected applyFormula(multiplicationResult: number): number {
        return multiplicationResult % this.moduloValue;
    }
}

class OntarioModuloCheck extends ModuloCheck {
    protected get multipliers(): number[] {
        return [2, 1, 2, 1, 2, 1, 2, 1, 2, 1];
    }

    protected get moduloValue(): number {
        return 10;
    }

    protected applyFormula(multiplicationResult: number): number {
        return multiplicationResult.getSumOfDigits();
    }
}

export { BritishColumbiaModuloCheck, OntarioModuloCheck };
